
import { actionWithLoader, getReplacingPath, onEnter, push } from "../Utils/utils"
import Parse from "parse"

export function showMisc() {
    return push("/misc")
}

export function loadPlanningRules() {
    return actionWithLoader(async (dispatch) => {
        const config = await new Parse.Query("GlobalConfig").first() || {}

        dispatch({
            type: "PLANNING_RULES_LOADED",
            planningRules: config.toJSON ? config.toJSON() : config
        })
    })
}

export function updatePlanningRulesSwitchOutputProduction(idPlanningRule, switchOutputProduction) {
    return actionWithLoader(async () => {
        const config = await new Parse.Query("GlobalConfig").first()
        if (!config) return
        config.set("switchOutputProduction", Boolean(switchOutputProduction))
        config.save()
    })
}

export function onEnterMisc(store) {
    return onEnter({
        store,
        actionThunk: loadPlanningRules,
        getReplacingPath: getReplacingPath({needUser: true})
    })
}

export const uploadUnpackingStepCSVForMigration = (lines) => {
    return actionWithLoader(async () => {
        await Parse.Cloud.run("migrateStepsToUnpackingProductionSteps", { lines })
    })
}

export const migratePasswordLastChangedAt = () => {
    return actionWithLoader(async (dispatch) => {
        const { migrated } = await Parse.Cloud.run("migratePasswordLastChangedAt")
        dispatch({
            type: "SUCCESS_MESSAGE",
            appSnackBar: {
                open: true,
                type: "success",
                message: `Migration terminée : ${migrated} compte(s) mis à jour`,
                duration: 5000,
            },
        })
    })
}